"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeb3ForKit = exports.ensureCurrentProvider = exports.setupAPIKey = exports.API_KEY_HEADER_KEY = void 0;
var net_1 = __importDefault(require("net"));
var web3_1 = __importDefault(require("web3"));
exports.API_KEY_HEADER_KEY = 'apiKey';
/** @internal */
function setupAPIKey(apiKey) {
    var options = {};
    options.headers = [];
    options.headers.push({
        name: exports.API_KEY_HEADER_KEY,
        value: apiKey,
    });
    return options;
}
exports.setupAPIKey = setupAPIKey;
/** @internal */
function ensureCurrentProvider(web3) {
    if (!web3.currentProvider) {
        throw new Error('Must have a valid Provider');
    }
}
exports.ensureCurrentProvider = ensureCurrentProvider;
/** @internal */
function getWeb3ForKit(url, options) {
    var web3;
    if (url.endsWith('.ipc')) {
        web3 = new web3_1.default(new web3_1.default.providers.IpcProvider(url, net_1.default));
    }
    else if (url.toLowerCase().startsWith('http')) {
        web3 = new web3_1.default(new web3_1.default.providers.HttpProvider(url, options));
    }
    else {
        web3 = new web3_1.default(url);
    }
    return web3;
}
exports.getWeb3ForKit = getWeb3ForKit;
//# sourceMappingURL=setupForKits.js.map